var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmIcon02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(-859 -3108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(-270 1694)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1129 1414)",
    fill: "#ff6a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26850",
    "data-name": "Path 26850",
    d: "M141.739-36.7a6.371,6.371,0,0,1-1.5.4c.241-.039.6-.452.736-.619a2.561,2.561,0,0,0,.5-.859c.013-.025.022-.055,0-.074a.088.088,0,0,0-.079.006,7.9,7.9,0,0,1-1.775.644.123.123,0,0,1-.123-.031,1.446,1.446,0,0,0-.155-.151,3.183,3.183,0,0,0-.861-.5,3.138,3.138,0,0,0-1.318-.2,3.272,3.272,0,0,0-1.251.335,3.194,3.194,0,0,0-1.009.782,2.889,2.889,0,0,0-.6,1.145,2.963,2.963,0,0,0-.032,1.209c.009.067,0,.077-.061.067a9.66,9.66,0,0,1-6.1-2.944c-.071-.077-.11-.077-.168.006a2.819,2.819,0,0,0,.527,3.465c.119.107.242.215.374.313a3.247,3.247,0,0,1-1.176-.313c-.071-.042-.108-.018-.113.059a1.622,1.622,0,0,0,.019.331,3,3,0,0,0,1.928,2.365,1.906,1.906,0,0,0,.391.114,3.693,3.693,0,0,1-1.154.033c-.084-.015-.117.025-.084.1a3.217,3.217,0,0,0,2.426,1.926c.11.018.219.018.33.042-.006.01-.013.01-.02.018a3.9,3.9,0,0,1-1.656.833,6.228,6.228,0,0,1-2.516.305c-.136-.019-.163-.018-.2,0s0,.052.039.085c.172.107.346.2.524.295a8.621,8.621,0,0,0,1.682.637,9.31,9.31,0,0,0,8.694-1.928,8.39,8.39,0,0,0,2.406-6.312c0-.091.113-.141.181-.189a5.716,5.716,0,0,0,1.183-1.166.343.343,0,0,0,.079-.224V-36.7C141.8-36.737,141.8-36.726,141.739-36.7Z",
    transform: "translate(1011.004 1462.085)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmIcon02);
export default __webpack_public_path__ + "static/media/sm-icon-02.c412b72ca67a69cd14a2dc9d7a6e90b1.svg";
export { ForwardRef as ReactComponent };